<script setup>
import { ref, onMounted } from 'vue'
import { useMainStore } from '@/stores/useMainStore.js'
import { emailBestaetigen } from '@/api/BestaetigungService.js'

import Loader from '@/components/loader.vue'
import email_erfolgreich from '@/components/email_erfolgreich.vue'
import email_fehler from '@/components/email_fehler.vue'

const mainStore = useMainStore()

// Status: 'loading', 'success', 'error'
const status = ref('loading')
const fehlermeldung = ref('')

onMounted(async () => {
    // Token aus data-code1 auslesen
    const token = mainStore.code1
    
    console.log('[Bestaetigung] Token aus code1:', token)
    
    if (!token) {
        status.value = 'error'
        fehlermeldung.value = 'Kein Bestätigungstoken gefunden.'
        return
    }
    
    // API-Call zur Bestätigung
    const result = await emailBestaetigen(token)
    
    if (result.success) {
        status.value = 'success'
    } else {
        status.value = 'error'
        fehlermeldung.value = result.nachricht
    }
})
</script>

<template>
    <div>
        <!-- Loader während des API-Calls -->
        <Loader v-if="status === 'loading'" />
        
        <!-- Erfolgsseite -->
        <email_erfolgreich v-else-if="status === 'success'" />
        
        <!-- Fehlerseite mit dynamischer Fehlermeldung -->
        <email_fehler v-else :fehlermeldung="fehlermeldung" />
    </div>
</template>
